import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyGoals } from '@/features/my-goals'

export const Route = createFileRoute('/_authenticated/_organization/my-goals/')({
  beforeLoad: async () => requireRoles(['client', 'primary_contact', 'supported_employee']),
  component: MyGoals,
})
